import Checkbox from '@components/form/Checkbox'
import { useState, useMemo } from 'react'
import { post } from '@api/apiFetcher'
import MessageHelper from '@utils/messageHelper'
import mutateUser from '@utils/user/mutateUser'
import useT from '@hooks/useTranslation'
import mix from '@utils/styles/mix'
import { SEND_PAYMENT_LINK_PAGE } from '@constants/routes'
import useRedirect from '@hooks/useRedirectBack'

import styles from 'styles/add/PaymentButton.module.css'

const PaymentButton = ({ user, price, orderCode, apiPath,
    onSuccess, onClose, onCancel,
    walletPayment = true }) => {

    const [createLink, setCreateLink] = useState(false)
    const [payWithWallet, setPayWithWallet] = useState(false)
    const [redirect] = useRedirect()

    const onClickCreateLink = ({ target: {checked}}) => setCreateLink(checked)
    const onClickPayWithWallet = ({ target: {checked}}) => setPayWithWallet(checked)

    const onPayment = () => {
        if (!price || !orderCode) return

        post({
            path: apiPath,
            data: { price, orderCode, payWithWallet },
            auth: user?.token, })

                .then((res) => {
                    MessageHelper.summary(res)

                    if (!res.success) return

                    if (res.wallet != null) {
                        mutateUser(user, { wallet: res.wallet })
                    }


                    if (createLink) {
                        const path = `${SEND_PAYMENT_LINK_PAGE}?link=${encodeURIComponent(res.link)}`
                        onClose()
                        redirect(path)
                        return
                    }

                    if (payWithWallet) {
                        return onSuccess(res)

                    } else {
                        onClose()
                        window.location.assign(res.link)
                    }
                })
    }

    return (
        <div>
            { !payWithWallet
                && <GeneratePaymentLink onClick={onClickCreateLink} /> }
            <br/>

            { walletPayment &&
                <PayWithWallet onClick={onClickPayWithWallet} funds={user?.wallet} price={price} /> }

            <div className={styles.buttons}>
                <CancelButton text="Nie, dziękuję" onClick={onCancel} />
                <PayButton text={`Zapłać %price z ${payWithWallet ? 'portfela' : 'PayU'}`} price={price} onClick={onPayment} />
            </div>
        </div>
    )
}

function GeneratePaymentLink ({ onClick }) {
    return (
        <div>
            <Checkbox
                name="stworz-link"
                label={useT('Wygeneruj link do płatności. Chcę zapłacić później') + '.'}
                register={()=>{}}
                onClick={onClick} />
        </div>
    )
}

function PayWithWallet ({ onClick, funds = 0, price = 0 }) {
    const isAvailable = funds >= price
    const zaplac = useT('Zapłać z portfela')
    const dostepne = useT('Dostępne środki')
    const label = useMemo(
        () => `${zaplac}. ${dostepne}: ${funds} zł`,
        [funds])

    return (
        <div style={isAvailable
            ? undefined
            : { opacity: 0.4, pointerEvents: 'none', userSelect: 'none' }}>

            <Checkbox
                name="zaplac-z-portfela"
                label={label}
                register={()=>{}}
                onClick={isAvailable
                    ? onClick
                    : undefined } />
        </div>
    )
}

function CancelButton ({ text, onClick }) {
    return (
        <button
            className="bt"
            onClick={onClick}>

            {useT(text)}
        </button>
    )
}

function PayButton ({ text, price, onClick }) {
    const displayText = useT(text).replace('%price', `${price} zł`)
    const disabled = price === 0
    return (
        <button
            className={mix([styles.button, disabled && styles.disabled])}
            onClick={disabled
                ? undefined
                : onClick}>

            {displayText}
        </button>
    )
}

export default PaymentButton